const NOT_CAPITALIZED_WORDS = ['de', 'da', 'do', 'das', 'dos'];
export default function normalizeCityName(cityName: string): string {
  if (!cityName) return null;
  const normalizedWords = cityName.split(' ').map(r => r?.trim()?.toLowerCase()).filter(Boolean).map(r => NOT_CAPITALIZED_WORDS.indexOf(r) >= 0 ? r : r[0].toUpperCase() + r.substring(1));
  return normalizedWords.join(' ');
}